"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemSettings = ItemSettings;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var react_dom_1 = require("react-dom");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var upload_file_1 = require("../../../../../api/calls/media/upload_file");
var letsachieve_1 = require("../../../../../api/letsachieve");
var dangerZone_1 = require("../../../../../components/dangerZone");
var read_only_banner_1 = require("../../../../../components/readOnlyBanner/read_only_banner");
var errors_1 = require("../../../../../helpers/errors");
var permissions_1 = require("../../../../../hooks/permissions");
var IUser_1 = require("../../../../../interfaces/IUser");
var item_1 = require("../../../../../reducers/slices/item/item");
var main_1 = require("../../../../../reducers/slices/main");
var constants_1 = require("../constants");
var useDeleteItem_1 = require("../hooks/useDeleteItem");
var toDraft = function (item) {
    var _a, _b, _c;
    return ({
        id: item.id,
        type: item.type,
        name: item.name,
        description: item.description,
        icon: (_a = item.icon) !== null && _a !== void 0 ? _a : {},
        dates_enabled: item.dates_enabled,
        start_date: item.start_date,
        end_date: item.end_date,
        quantity_limited: item.quantity_limited,
        quantity: item.quantity,
        stackable: item.stackable,
        consumable: __assign(__assign(__assign({}, item_1.defaultConsumable), item.consumable), { uses_per_unit: ((_b = item.consumable) === null || _b === void 0 ? void 0 : _b.uses_per_unit) || item_1.defaultConsumable.uses_per_unit }),
        badge: item.type === "badge" ? __assign(__assign(__assign({}, item_1.defaultBadgeSettings), item.badge), { theme: __assign(__assign({}, item_1.defaultBadgeSettings.theme), (_c = item.badge) === null || _c === void 0 ? void 0 : _c.theme) }) : undefined,
    });
};
var toConsumable = function (_a) {
    var enabled = _a.enabled, uses_per_unit = _a.uses_per_unit, expires_after_days = _a.expires_after_days;
    return enabled ? { enabled: enabled, uses_per_unit: uses_per_unit, expires_after_days: expires_after_days || null } : { enabled: false, uses_per_unit: 0, expires_after_days: null };
};
var toCreateRequest = function (draft, icon) { return ({
    type: draft.type,
    name: draft.name.trim(),
    description: draft.description.trim(),
    icon: icon,
    dates_enabled: draft.dates_enabled,
    start_date: draft.dates_enabled ? draft.start_date : null,
    end_date: draft.dates_enabled ? draft.end_date : null,
    quantity_limited: draft.quantity_limited,
    quantity: draft.quantity_limited ? draft.quantity : 0,
    stackable: draft.stackable,
    consumable: toConsumable(draft.consumable),
    badge: draft.type === "badge" ? draft.badge : undefined,
}); };
// a missing date key leaves the stored date alone and null clears it, so only changed dates are sent
var toUpdateRequest = function (draft, item, icon) {
    var _a, _b;
    var _c = toCreateRequest(draft, icon), type = _c.type, start_date = _c.start_date, end_date = _c.end_date, body = __rest(_c, ["type", "start_date", "end_date"]);
    var request = body;
    if ((start_date !== null && start_date !== void 0 ? start_date : null) !== ((_a = item.start_date) !== null && _a !== void 0 ? _a : null))
        request.start_date = start_date !== null && start_date !== void 0 ? start_date : null;
    if ((end_date !== null && end_date !== void 0 ? end_date : null) !== ((_b = item.end_date) !== null && _b !== void 0 ? _b : null))
        request.end_date = end_date !== null && end_date !== void 0 ? end_date : null;
    return request;
};
var isWholeNumber = function (value) { return Number.isInteger(value) && value >= 1; };
var validateDraft = function (draft, hasIcon, item) {
    var _a;
    var errors = {
        name: draft.name.trim() ? "" : "Name is required",
        description: draft.description.trim() ? "" : "Description is required",
        icon: hasIcon ? "" : "Icon is required",
    };
    var issuedCount = (_a = item === null || item === void 0 ? void 0 : item.issued_count) !== null && _a !== void 0 ? _a : 0;
    var limitChanged = !item || draft.quantity_limited !== item.quantity_limited || draft.quantity !== item.quantity;
    if (draft.quantity_limited) {
        if (!draft.quantity || draft.quantity <= 0)
            errors.quantity = "Quantity must be greater than 0";
        else if (limitChanged && draft.quantity < issuedCount)
            errors.quantity = "Quantity cannot be below the ".concat(issuedCount.toLocaleString(), " already issued");
    }
    if (draft.consumable.enabled) {
        errors.consumable = {
            uses_per_unit: isWholeNumber(draft.consumable.uses_per_unit) ? "" : "Uses per unit must be a whole number of at least 1",
            expires_after_days: draft.consumable.expires_after_days == null || isWholeNumber(draft.consumable.expires_after_days) ? "" : "Expiry must be a whole number of days, at least 1",
        };
    }
    if (draft.dates_enabled) {
        errors.start_date = draft.start_date ? "" : "Start date is required";
        errors.end_date = draft.end_date ? "" : "End date is required";
        if (draft.start_date && draft.end_date && new Date(draft.start_date) >= new Date(draft.end_date)) {
            errors.end_date = "End date must be after start date";
        }
    }
    return errors;
};
function ItemSettings(_a) {
    var _this = this;
    var item = _a.item, item_type = _a.item_type, actions_container = _a.actions_container, preview = _a.preview, render_sections = _a.render_sections, validate_type = _a.validate_type;
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _b = (0, react_redux_1.useSelector)(function (state) { return state.itemState; }), selectedItem = _b.selectedItem, isEdited = _b.isEdited, isFileEdited = _b.isFileEdited, file = _b.file;
    var _c = (0, letsachieve_1.useCreateItemMutation)(), createItem = _c[0], isCreating = _c[1].isLoading;
    var _d = (0, letsachieve_1.useUpdateItemMutation)(), updateItem = _d[0], isUpdating = _d[1].isLoading;
    var confirmDelete = (0, useDeleteItem_1.useDeleteItem)().confirmDelete;
    var isEditMode = Boolean(item === null || item === void 0 ? void 0 : item.id);
    var _e = (0, permissions_1.usePermission)(IUser_1.IPermissions.BADGES), canCreate = _e.canCreate, canUpdate = _e.canUpdate, canDelete = _e.canDelete;
    var canEdit = isEditMode ? canUpdate : canCreate;
    var typeLabel = (0, constants_1.itemTypeLabel)(item_type).toLowerCase();
    // seeds the draft only while nothing has been edited, so a background refetch cannot overwrite work in progress
    (0, react_3.useEffect)(function () {
        if (item && !isEdited)
            dispatch((0, item_1.setSelectedItem)(toDraft(item)));
    }, [item, isEdited, dispatch]);
    (0, react_3.useEffect)(function () {
        var _a, _b;
        if (item || selectedItem.type === item_type)
            return;
        var stackable = (_b = (_a = constants_1.itemTypeOptions.find(function (option) { return option.key === item_type; })) === null || _a === void 0 ? void 0 : _a.stackable) !== null && _b !== void 0 ? _b : selectedItem.stackable;
        dispatch((0, item_1.setSelectedItem)(__assign(__assign({}, selectedItem), { type: item_type, stackable: stackable })));
    }, [item, item_type, selectedItem, dispatch]);
    (0, react_3.useEffect)(function () { return function () {
        dispatch((0, item_1.clearState)());
    }; }, [dispatch]);
    var uploadIcon = function () { return __awaiter(_this, void 0, void 0, function () {
        var response;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!isFileEdited || !file)
                        return [2 /*return*/, selectedItem.icon];
                    return [4 /*yield*/, (0, upload_file_1.upload_file)({
                            file: file,
                            type: "IMAGE",
                            file_name: file.name,
                            description: selectedItem.description,
                            category: "".concat(selectedItem.type, "_icon"),
                        })];
                case 1:
                    response = _d.sent();
                    if (!(response === null || response === void 0 ? void 0 : response.success)) {
                        dispatch((0, main_1.setMessageModal)({ title: "Something went wrong when uploading your icon!", messages: [(_a = response === null || response === void 0 ? void 0 : response.message) !== null && _a !== void 0 ? _a : "The upload was unsuccessful."] }));
                        return [2 /*return*/, undefined];
                    }
                    return [2 /*return*/, { url: (_b = response === null || response === void 0 ? void 0 : response.content) === null || _b === void 0 ? void 0 : _b.location, etag: (_c = response === null || response === void 0 ? void 0 : response.content) === null || _c === void 0 ? void 0 : _c.etag, file_name: file.name }];
            }
        });
    }); };
    var handleSave = function () { return __awaiter(_this, void 0, void 0, function () {
        var errors, errorList, icon, updateBody, saved, created, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    errors = __assign(__assign({}, validateDraft(selectedItem, Boolean(file || ((_a = selectedItem.icon) === null || _a === void 0 ? void 0 : _a.url) || ((_b = selectedItem.icon) === null || _b === void 0 ? void 0 : _b.name)), item)), validate_type === null || validate_type === void 0 ? void 0 : validate_type(selectedItem));
                    dispatch((0, item_1.setErrors)(errors));
                    errorList = (0, errors_1.generateErrorList)(errors);
                    if (errorList.length) {
                        dispatch((0, main_1.setMessageModal)({ title: "Validation Error", messages: __spreadArray(["Please correct the following errors: ", ""], errorList, true) }));
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, uploadIcon()];
                case 1:
                    icon = _c.sent();
                    if (!icon)
                        return [2 /*return*/];
                    _c.label = 2;
                case 2:
                    _c.trys.push([2, 7, , 8]);
                    if (!isEditMode) return [3 /*break*/, 4];
                    updateBody = toUpdateRequest(selectedItem, item, icon);
                    return [4 /*yield*/, updateItem({ item_id: item.id, body: updateBody }).unwrap()];
                case 3:
                    saved = _c.sent();
                    dispatch((0, item_1.setIsEdited)(false));
                    dispatch((0, item_1.setFileEdited)(false));
                    dispatch((0, item_1.setSelectedItem)(toDraft(saved !== null && saved !== void 0 ? saved : __assign(__assign({}, item), updateBody))));
                    dispatch((0, main_1.setMessageModal)({ title: "Success!", messages: ["Successfully updated your ".concat(typeLabel, ".")] }));
                    return [3 /*break*/, 6];
                case 4: return [4 /*yield*/, createItem(toCreateRequest(selectedItem, icon)).unwrap()];
                case 5:
                    created = _c.sent();
                    dispatch((0, item_1.setIsEdited)(false));
                    navigate((created === null || created === void 0 ? void 0 : created.id) ? (0, constants_1.itemPagePath)(created.type, created.id) : (0, constants_1.itemsListPath)());
                    _c.label = 6;
                case 6: return [3 /*break*/, 8];
                case 7:
                    error_1 = _c.sent();
                    dispatch((0, main_1.setMessageModal)({ title: "Something went wrong when saving your ".concat(typeLabel, "!"), messages: [(0, constants_1.itemErrorMessage)(error_1)] }));
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var saveButton = canEdit ? ((0, jsx_runtime_1.jsxs)(react_1.Button, { size: "md", onPress: handleSave, isPending: isCreating || isUpdating, isDisabled: !isEdited, variant: "primary", children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "mdi:content-save", width: 24 }), "Save"] })) : null;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-6 pb-8", children: [actions_container && saveButton ? (0, react_dom_1.createPortal)(saveButton, actions_container) : null, !canEdit && (0, jsx_runtime_1.jsx)(read_only_banner_1.ReadOnlyBanner, { feature: "".concat(typeLabel, "s"), className: "w-full" }), (0, jsx_runtime_1.jsxs)("div", { className: "grid grid-cols-1 items-start gap-8 md:grid-cols-[minmax(0,1fr)_19rem] xl:grid-cols-3", children: [(0, jsx_runtime_1.jsx)("div", { className: "@container flex min-w-0 flex-col gap-10 xl:col-span-2", children: render_sections(!canEdit) }), (0, jsx_runtime_1.jsxs)(react_1.Card, { className: "md:sticky md:top-0", children: [(0, jsx_runtime_1.jsx)(react_1.Card.Header, { children: (0, jsx_runtime_1.jsx)(react_1.Card.Title, { className: "text-base font-semibold text-primary", children: "Preview" }) }), (0, jsx_runtime_1.jsx)(react_1.Card.Content, { children: preview })] })] }), isEditMode && canDelete && ((0, jsx_runtime_1.jsx)(dangerZone_1.DangerZone, { title: "Delete this ".concat(typeLabel), description: "It can no longer be granted. Players keep what they hold and the history is kept.", button_label: "Delete ".concat(typeLabel), on_press: function () { return confirmDelete(item, function () { return navigate((0, constants_1.itemsListPath)()); }); } }))] }));
}
